import http from "../../core/services/http.service";
import {AppSettings} from "@/shared/AppSettings";

const ConditionReportImagesService = {
    getConditionReportImages(uuid, expand, params = null) {
        return http.get(`/api/v1/inventories/${uuid}/condition-reports-images/?expand=${expand}`, {params});
    },
    createConditionReportImages(formData, onUploadProgress) {
        return http.post(AppSettings.getUrl(`/api/v1/inventories/condition-reports-images/?expand=created_by`), formData, {
            headers: {'Content-Type': 'multipart/form-data'}, onUploadProgress
        });
    },
    removeConditionReportImage(uuid) {
        return http.delete(`/api/v1/inventories/condition-reports-images/${uuid}/`);
    },
};

export default ConditionReportImagesService;
